import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { TaxSettingsProps } from "../../common/types/tax/types"
import { StaticBackdrop } from "../../common/modal"
import { TAX_SETTINGS_MESSAGES } from "../../utils/tax"
import { FeatureProtectedToggle } from "../../common/rich-text/feature-protection-wrappers"
import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Service from "../../state/account/service"
import {
    ACCOUNT_SETTINGS,
    isAccountEligibleForDynamicTaxFeature,
} from "../../utils/account"
import GlobalHelper from "../../common/GlobalHelper"

export const TaxSettings = injectIntl((props: TaxSettingsProps) => {
    const [isEnabled, setIsEnabled] = useState(AppContext.accountSettingIsEnabled(AccountFeatures.FeatureDynamicTax))

    if (!isAccountEligibleForDynamicTaxFeature(AppContext.getAccount())) {
        return null
    }

    const onChange = (isToggled: boolean) => {
        Service.patch({
            settings: [{
                key: ACCOUNT_SETTINGS.DYNAMIC_TAX,
                enabled: isToggled,
            }]
        }).then(() => {
            setIsEnabled(AppContext.accountSettingIsEnabled(AccountFeatures.FeatureDynamicTax))
        })
    }

    return (
        <>
            <StaticBackdrop>
                <div className="d-flex align-items-center mb-2">
                    <h5 className="mr-2 mb-0 pb-0 border-0">{props.intl.formatMessage(TAX_SETTINGS_MESSAGES.dynamicTax)}</h5>
                    <FeatureProtectedToggle
                        featureKey={AccountFeatures.FeatureDynamicTax}
                        checked={isEnabled}
                        onChange={e => onChange(e.target.checked)}
                    />

                </div>

                <small className="text-muted">
                    {props.intl.formatMessage(TAX_SETTINGS_MESSAGES.description)}
                </small>

            </StaticBackdrop>
        </>
    )
})




// WEBPACK FOOTER //
// ./src/settings/taxes/TaxSettings.tsx